var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Digit",class:{ focus: _vm.focus, empty: _vm.digit === '-' }},[_c('span',{staticClass:"content"},[_vm._v("\n        "+_vm._s(_vm.digit === '-' ? _vm.placeholder : _vm.digit)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }